/// <amd-module name="Artifacts/Package/redux/Selectors" />

import { IPackageDetailsModuleState } from "Artifacts/Package/redux/Contracts";
import { IPackage } from "Artifacts/Root/types/IPackage";

export function getSelectedPackage(state: IPackageDetailsModuleState): IPackage | undefined {
  return state.packageState.data.pkg;
}
